import { configureStore } from '@reduxjs/toolkit';
import { type Reducer } from 'redux';

import { type RootState } from '../services/types';

const createMockUserReducer = (): Reducer<RootState['user']> => {
  const initialState: RootState['user'] = {
    messages: {
      'roleRecs.card.description.wrapper':
        'This role is for users whose {description}.',
      'roleRecs.card.description.condition': '{attribute} is {values}',
      'roleRecs.dashboard.title': 'Roles Dashboard',
      'roleRecs.dashboard.subtitle':
        'Suggested Roles from Intelligent Recommendations',
      'intelRecs.shared.button.viewDetails': 'View Details',
    },
    userInfo: {
      userSavRoleMap: {
        locale: 'en', // locale for grammar rules in generateRoleDescription
      },
    },
    isMenuPinned: false,
  };

  return (state = initialState) => state;
};

export default function getMinimalStore(
  customReducers?: Record<string, Reducer>
) {
  return configureStore({
    reducer: {
      user: createMockUserReducer(),
      // add other reducers as needed
      ...(customReducers ?? {}),
    },
  });
}
